import firebase from "firebase/compat/app";
import "firebase/compat/auth";
import "firebase/compat/database";
import { initializeApp } from 'firebase/app';
import { getDatabase } from 'firebase/database';
import { getAuth } from 'firebase/auth';

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
  databaseURL: import.meta.env.VITE_FIREBASE_DATABASE_URL,
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
  appId: import.meta.env.VITE_FIREBASE_APP_ID
};

// Initialize Firebase (compat version for existing code)
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig);
}

// Initialize Firebase (v9 modular SDK for admin)
const app = initializeApp(firebaseConfig);
export const database = getDatabase(app);
export const firebaseAuth = getAuth(app);

// Export auth services (compat)
export const auth = firebase.auth();
export const googleProvider = new firebase.auth.GoogleAuthProvider();

// Export database service (compat)
export const db = firebase.database();